const keyCodes = {
    48: 'Digit0', // 0
    41: 'Digit0', // )

    33: 'Digit1', // !
    49: 'Digit1', // 1

    50: 'Digit2', // 2
    64: 'Digit2', // @

    35: 'Digit3', // #
    51: 'Digit3', // 3

    52: 'Digit4', // 4
    36: 'Digit4', // $

    53: 'Digit5', // 5
    37: 'Digit5', // %

    54: 'Digit6', // 6
    94: 'Digit6', // ^

    55: 'Digit7', // 7
    38: 'Digit7', // &

    56: 'Digit8', // 8
    42: 'Digit8', // *

    57: 'Digit9', // 9
    40: 'Digit9', // (

    126: 'BQuote', // ~
    96: 'BQuote', // `

    44: 'Comma', // ,
    60: 'Comma', // <

    62: 'Period', // >
    46: 'Period', // .

    47: 'Slash', // /
    63: 'Slash', // ?

    58: 'Smcln', // :
    59: 'Smcln', // ;

    34: 'Quote', // "
    39: 'Quote', // '

    91: 'BtL', // [
    123: 'BtL', // {

    93: 'BtR', // ]
    125: 'BtR', // }

    92: 'BSlash', // \
    124: 'BSlash', // |

    65: 'A',
    66: 'B',
    67: 'C',
    68: 'D',
    69: 'E',
    70: 'F',
    71: 'G',
    72: 'H',
    73: 'I',
    74: 'J',
    75: 'K',
    76: 'L',
    77: 'M',
    78: 'N',
    79: 'O',
    80: 'P',
    81: 'Q',
    82: 'R',
    83: 'S',
    84: 'T',
    85: 'U',
    86: 'V',
    87: 'W',
    88: 'X',
    89: 'Y',
    90: 'Z',

    32: 'Space',
    13: 'Enter',
    61: 'Equal',
    43: 'Equal',
    45: 'Minus',
    95: 'Minus',
}

export {keyCodes as default}